
<div class="md:mt-64 px-16 md:w-568 mx-auto">
  <h1 class="text-h2 mb-16 text-center">About your family</h1>
  <p class="text-body mb-24 text-center">Tells us a little more about your children needing care.</p>

  <Card :clickable="false" class="w-full block md:w-368 mx-auto md:p-24">
    <form>
      <Dropdown
        id="children"
        v-model="numberOfChildren"
        labelName="Number of children"
        class="mb-32"
        name="children"
        :options="childrenNumberOptions"
        :status="errors.numberOfChildren ? HelperStatus.Error : HelperStatus.Neutral"
        :helperText="errors.numberOfChildren"
      />
      <div class="mb-32">
        <legend id="age-of-children" class="text-strong-body mb-16">Age of children</legend>
        <Checkbox
          v-for="age in ageOptions"
          :id="age.value"
          :key="age.value"
          v-model="ageGroups"
          :labelName="age.label"
          :value="age.value"
        />
        <HelperText v-if="errors.ageGroups" :status="HelperStatus.Error" :text="errors.ageGroups" />
      </div>
      <div class="flex flex-row-reverse">
        <RouteStepperNextButton
          :stepData="reviewSection"
          :draftData="draftData"
          :validate="validate"
          @errors="errors = $event"
        />
      </div>
    </form>
  </Card>
</div>
